/**
 * @generated SignedSource<<1850ffb62d49255c02cb30667bf1aed4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteScheduleItemMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
};
export type DeleteScheduleItemMutation$data = {
  readonly deleteScheduleItem: {
    readonly deletedItem: {
      readonly id: string | null | undefined;
    } | null | undefined;
    readonly parentItem: {
      readonly children: string | null | undefined;
      readonly id: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type DeleteScheduleItemMutation = {
  response: DeleteScheduleItemMutation$data;
  variables: DeleteScheduleItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "DeleteScheduleItemPayload",
    "kind": "LinkedField",
    "name": "deleteScheduleItem",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ScheduleItem",
        "kind": "LinkedField",
        "name": "deletedItem",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ScheduleItem",
        "kind": "LinkedField",
        "name": "parentItem",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "children",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteScheduleItemMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DeleteScheduleItemMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "64debe28c53a134277f7afca7dcb298f",
    "id": null,
    "metadata": {},
    "name": "DeleteScheduleItemMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteScheduleItemMutation(\n  $id: ID!\n) {\n  deleteScheduleItem(id: $id) {\n    deletedItem {\n      id\n    }\n    parentItem {\n      id\n      children\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3f1b6bb097e6b1903800b4a95ecc2d81";

export default node;
